/* global axios */
import ApiClient from './ApiClient';

class DocumentsAPI extends ApiClient {
  constructor() {
    super('documents', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(formData) {
    return axios.post(this.url, formData);
  }

  update(id, document) {
    return axios.patch(`${this.url}/${id}`, { document });
  }

  transition(id, status, note = '') {
    return axios.post(`${this.url}/${id}/transition`, { status, note });
  }

  createVersion(id, formData) {
    return axios.post(`${this.url}/${id}/versions`, formData);
  }

  download(id, versionId = null) {
    return axios.get(`${this.url}/${id}/download`, {
      responseType: 'blob',
      params: versionId ? { version_id: versionId } : {},
    });
  }

  getConversationMessages(id) {
    return axios.get(`${this.url}/${id}/conversation_messages`);
  }

  signatureBuilderToken(id) {
    return axios.get(`${this.url}/${id}/signature_builder_token`);
  }

  signatureBuilder(id) {
    return axios.get(`${this.url}/${id}/signature_builder`);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new DocumentsAPI();
